import type { Root } from 'mdast';
import type { VFile } from 'vfile';
import { visit } from 'unist-util-visit';

import { POLL_MDX_DIRECTIVE_NAME } from './pollMdxDirectiveConstants';

export const pollMdxDirectiveRemarkPlugin =
  () =>
  (tree: Root, file: VFile): void => {
    visit(tree, function (node) {
      if (node.type === 'leafDirective') {
        if (node.name !== POLL_MDX_DIRECTIVE_NAME) {
          return;
        }

        // eslint-disable-next-line no-param-reassign
        const data = node.data ?? (node.data = {});
        const attributes = node.attributes ?? {};

        const pollId = attributes.pollId;
        if (!pollId) {
          file.fail(
            `Unexpected missing \`id\` on \`${POLL_MDX_DIRECTIVE_NAME}\` directive.`,
            node,
          );
        }

        data.hName = 'crowdaa-press-poll';
        data.hProperties = {
          id: pollId,
        };
      }
    });
  };
